// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ZesSM{display:flex;align-items:center;gap:8px}.YQzxr{display:flex;gap:4px}.YdB7M{min-width:0;overflow:hidden}.YdB7M>label{min-width:0;overflow:hidden}.YdB7M .YQzxr{min-width:0;overflow:hidden}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `ZesSM`,
	"label": `YQzxr`,
	"ellipsis": `YdB7M`
};
export default ___CSS_LOADER_EXPORT___;
